import React from "react";
import { Game } from "../../interfaces/game.interface";
import { useGameNavigator } from "../../hooks/useGameNavigator";

export const HighscoreGame: React.FC<{ game: Game; score: number }> = ({
  game,
  score,
}) => {
  const { isGamePlayable, navigateToGame } = useGameNavigator(game);

  return (
    <div className="">
      <img
        src={game.thumbnail}
        className="w-full h-[180px] object-cover rounded-lg mb-4 cursor-pointer"
        alt={game.id}
        onClick={() => navigateToGame()}
      />
      <h5 className="font-bold text-[16px] mb-2">{game.id}</h5>
      <div className="flex items-center justify-between gap-8">
        <div className="flex-0 px-4 py-2 rounded-lg bg-[#8dca8333]">
          <span className="font-medium text-[10px]">High Score:</span>
          <span className="font-bold text-[#46D27E] ml-1 text-[16px]">
            {score}
          </span>
        </div>

        {isGamePlayable && (
          <button
            className="flex-1 font-bold text-[14px] bg-green-300 rounded-md px-6 py-2"
            onClick={() => navigateToGame()}
          >
            Challenge Your Highscore
          </button>
        )}
      </div>
    </div>
  );
};
